<template>
	<!-- 重要提示样式 -->
	<div class="notice">
		<div class="notice-title flex-startCenter ">
			<i class="el-icon-warning-outline font18 color-orange margin-right5"></i>
			重要提示：
		</div>
		<span class="notice-content">
			{{text}}
		</span>
	</div>
</template>

<script>
	export default {
		name: 'ComNotice',
		props: {
			text: {
				type: String,
				default: ''
			}
		}
	}
</script>

<style lang="scss" scoped>
	.notice {
		padding: 14px;
		background-color: rgba(255, 105, 16, 0.06);
		border-radius: 5px;
		color: #606266;
		font-size: 13px;
		margin-top: 30px;
		border: 1px dashed #FF6910;

		.notice-title {
			font-weight: 500;
			font-size: 15px;
			margin-bottom: 5px;
		}
	}
</style>